export const LOAD_MORE_CTA_COPY = "Laporan Lain";
export const READ_MORE_CTA_COPY = "Laporan Lanjut";
